export const testJson = [
  {
    val: "IELTS",
  },
  {
    val: "TOEFL",
  },
  {
    val: "PTE",
  },
  {
    val: "GMAT",
  },
  {
    val: "GRE",
  },
  {
    val: "Other",
  },
];

export const Universities = [
  {
    Id: 600,
    Name: "Victoria University - ECA",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Victoria_University_Sydney.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/victoria_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/victoria_university.png",
  },

  {
    Id: 2,
    Name: "University of Canberra",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_canberra.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_canberra.png",
  },

  {
    Id: 30,
    Name: "University of Tasmania",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_tasmania.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_tasmania.png",
  },

  {
    Id: 24,
    Name: "University of the Sunshine Coast",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/University_of_the_Sunshine_Coast.jpg",
    Logo310x125: null,
  },
  {
    Id: 31,
    Name: "Deakin University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Deakin_University.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/deakin_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/deakin.png",
  },
  {
    Id: 17,
    Name: "Central Queensland University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Central_Queensland_University_(CQU).jpg",
    Logo55x55: "https://doc.searcheducation.in/university/55x55/Logo55x55.jpg",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 15,
    Name: "Charles Darwin University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Charles_Darwin_University.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/charles_darwin_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/charles_darwin_university.png",
  },
  {
    Id: 13,
    Name: "Western Sydney University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Western_Sydney_University_jpg_1722322153583.jpg",
    Logo55x55: "https://doc.searcheducation.in/university/55x55/Logo55x55.jpg",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 20,
    Name: "James Cook University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/James_Cook_University_jpg_1684399152128.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/james_cook_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/james_cook_university.png",
  },

  {
    Id: 32,
    Name: "La Trobe University",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/la_trobe_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/la_trobe_university.png",
  },
  {
    Id: 698,
    Name: "Saibt leading to UNISA",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Saibt_leading_to_UNISA_jpg_1684993343864.jpg",
    Logo55x55: null,
    Logo310x125: null,
  },
  {
    Id: 34,
    Name: "RMIT University",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/rmit_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/rmit_university.png",
  },
  {
    Id: 6,
    Name: "Macquarie University",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/macquarie_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/macquarie_university.png",
  },
  {
    Id: 12,
    Name: "University of Technology, Sydney",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_technology,_sydney.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_technology,_sydney.png",
  },
  {
    Id: 35,
    Name: "Swinburne University of Technology",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Swinburne_University_Sydney_jpg_1685011493556.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/swinburne_university_of_technology.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/swinburne_university_of_technology.png",
  },
  {
    Id: 37,
    Name: "University of Melbourne",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_melbourne.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_melbourne.png",
  },
  {
    Id: 1,
    Name: "Australian National University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Australian_National_University_3_jpg_1701752329401.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/australian_national_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/australian_national_university.png",
  },
  {
    Id: 11,
    Name: "University of Sydney",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_sydney.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_sydney.png",
  },
  {
    Id: 22,
    Name: "University of Queensland",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_queensland.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_queensland.png",
  },
  {
    Id: 43,
    Name: "University of Western Australia",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_western_australia.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_western_australia.png",
  },
  {
    Id: 28,
    Name: "University of Adelaide",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_adelaide.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_adelaide.png",
  },
  {
    Id: 33,
    Name: "Monash University",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Monash-University.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/monash_university.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/monash_university.png",
  },

  {
    Id: 9,
    Name: "University of New South Wales",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University-of-New-South-Wales.jpg",
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/university_of_new_south_wales.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/university_of_new_south_wales.png",
  },
  {
    Id: 245,
    Name: "London Metropolitan University ",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/London_Metropolitan_University_jpg_1684230530518.jpg",
    Logo55x55: "https://doc.searcheducation.in/university/55x55/Logo55x55.jpg",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 288,
    Name: "University of Northampton",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University-of-Northampton.jpg",
    Logo55x55: "https://doc.searcheducation.in/university/55x55/Logo55x55.jpg",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 202,
    Name: "Heriot-Watt University ",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/_1683545505026.jpg",
    Logo55x55: "https://doc.searcheducation.in/university/Heriot_watt.png",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 744,
    Name: "Stanley College",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/Stanley_College_jpg_1685009088167.jpg",
    Logo55x55: null,
    Logo310x125: null,
  },
  {
    Id: 432,
    Name: "University of South Wales",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University_of_South_Wales_jpg_1686808887049.jpg",
    Logo55x55: "https://doc.searcheducation.in/university/55x55/Logo55x55.jpg",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 149,
    Name: "Coventry University ", //need
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/Coventry_University.jpg",
    Logo310x125: null,
  },
  {
    Id: 362,
    Name: "University of Surrey ",
    Logo134x64:
      "https://doc.searcheducation.in/university/Logo134x64/University_of_Surrey_jpg_1686809895078.jpg",
    Logo55x55: "https://doc.searcheducation.in/university/55x55/Logo55x55.jpg",
    Logo310x125:
      "https://doc.searcheducation.in/university/310x125/Logo310x125.jpg",
  },
  {
    Id: 662,
    Name: "The University of Law",
    Logo134x64: null,
    Logo55x55:
      "https://doc.searcheducation.in/university/55x55/University_Of_Law.jpg",
    Logo310x125: null,
  },
];


